import { Link } from "react-router-dom";
import { EmptyState } from "@/components/new-look/blocks";
import { MENU } from "@/components/new-look/labels";
import { usePageTitle } from "@/hooks/use-page-title";

/**
 * Placeholders for menu items whose pages come later in the new look
 * (docs/new-look/PLAN.md: Devices and Connections are later projects,
 * Projects is step 7.2).
 */

function ComingSoon({
  title,
  body,
  link,
}: {
  title: string;
  body: string;
  link?: { to: string; label: string };
}) {
  usePageTitle(title);
  return (
    <div className="mx-auto flex max-w-3xl flex-col gap-6 py-6">
      <h1 className="text-3xl font-bold tracking-tight text-foreground">{title}</h1>
      <EmptyState
        title="Coming soon"
        body={body}
        action={
          link ? (
            <Link
              to={link.to}
              className="inline-flex min-h-11 items-center rounded-lg border border-border px-4 text-sm font-medium text-foreground hover:bg-muted"
            >
              {link.label}
            </Link>
          ) : undefined
        }
      />
    </div>
  );
}

export function DevicesPage() {
  return (
    <ComingSoon
      title={MENU.devices}
      body="Physical products: firmware, bench prototypes on a Raspberry Pi or Arduino, circuit boards and pilot batches, each built from an idea like the rest of CompBox."
    />
  );
}
